import React from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter } from "helpers/string";

import TableCell from "components/Tables/TableCell";

export default function TransportBodyType({ content }) {
    const { t } = useTranslation();
    const hasAdr =
        content.transport_exchanges_adr_items?.length ||
        content.transport_exchanges_adr_captions?.length;
    let description = [];

    if (content.transport_bodytype_additional) {
        description.push(content.transport_bodytype_additional.value);
    }

    // Формируем строку с весом и габаритами
    const carryingCapacity = parseFloat(content.carrying_capacity);
    const length = parseFloat(content.length);
    const width = parseFloat(content.width);
    const height = parseFloat(content.height);
    const volume = parseFloat(content.volume);

    let dimensions = [];

    // Расстояние маршрута
    if (content.route_distance_meters) {
        const distanceKm = Math.round(content.route_distance_meters / 1000);
        dimensions.push(`${distanceKm} ${t("units.km")}`);
    }

    // Вес
    if (carryingCapacity > 0) {
        dimensions.push(`${carryingCapacity} ${t("units.tons")}`);
    }

    // Габариты (ДxШxВ)
    const sizeParts = [];
    if (length > 0) sizeParts.push(length);
    if (width > 0) sizeParts.push(width);
    if (height > 0) sizeParts.push(height);
    if (sizeParts.length > 0) {
        dimensions.push(`${sizeParts.join("x")} ${t("units.m")}`);
    }

    // Объём
    if (volume > 0) {
        dimensions.push(`${volume} ${t("units.m3")}`);
    }

    const dimensionsText = dimensions.join(", ");

    // Handle bodytypes as array with truncation
    const MAX_VISIBLE_BODYTYPES = 4;
    const bodytypes = content.transport_bodytypes || [];
    const hasMoreBodytypes = bodytypes.length > MAX_VISIBLE_BODYTYPES;
    const visibleBodytypes = bodytypes.slice(0, MAX_VISIBLE_BODYTYPES);
    const remainingCount = bodytypes.length - MAX_VISIBLE_BODYTYPES;

    const bodyTypesTitle = visibleBodytypes.length > 0
        ? visibleBodytypes.map((bt) => capitalizeFirstLetter(bt.value)).join(", ") +
          (hasMoreBodytypes ? ` +${remainingCount}` : "")
        : null;
    const allBodytypesTitle = bodytypes.map((bt) => capitalizeFirstLetter(bt.value)).join(", ");

    return (
        <TableCell
            title={bodyTypesTitle}
            titleTooltip={hasMoreBodytypes ? allBodytypesTitle : undefined}
            description={capitalizeFirstLetter(description.join(", "))}
            additional={dimensionsText}
        />
    );
}
